import React from 'react';
import { useStores } from '../../hooks/use-stores';
import { useNavigate, useResolvedPath } from 'react-router-dom';
import { joinPath } from '../../utils/helpers';
import TrainingView from '../Trainings/TrainingView';

function DemoTraining({ trainingId, isAdmin }) {
    const navigate = useNavigate();

    const resolved = useResolvedPath('.');
    const baseUrl = resolved.pathname;
    const { demoStore, store } = useStores();

    const handleOnFinish = () => {
        isAdmin
            ? navigate(joinPath(baseUrl, 'finish'))
            : navigate(joinPath(baseUrl, 'give-feedback'));
    };

    return (
        <TrainingView
            trainingId={trainingId}
            language={store.language}
            trainingStore={demoStore}
            store={demoStore}
            videoTokenStore={store}
            redirectOnError={false}
            onClose={handleOnFinish}
            isDemo
        />
    );
}

export default DemoTraining;
